import { handleLogin, getInfo } from '@/api/login'
import { getToken, setToken, removeToken, removeRefreshToken } from '@/utils/auth'
import { messageList } from '@/api/message.js'

const user = {
  state: {
    token: getToken(),
    userInfo: {},
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    auditManager: {
      username: process.env.VUE_APP_AUDIT_MANAGER
    },
    mssageUnreadCount: 0
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO(state, data) {
      state.userInfo = data
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_UNREADMSSAGE: (state, list) => {
      state.mssageUnreadCount = list
    }
  },

  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        handleLogin(userInfo)
          .then(res => {
            if (+res.code === 0) {
              setToken(res.result)
              commit('SET_TOKEN', res.result)
              resolve()
            } else {
              reject(res)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            const user = res.result
            commit('SET_USERINFO', user)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    GetMessageUnRead({ commit }) {
      return new Promise((resolve, reject) => {
        messageList({
          page: 1,
          eachpage: 5,
          hideRead: true
        })
          .then(res => {
            commit('SET_UNREADMSSAGE', res.result.total)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        removeRefreshToken()
        removeToken()
        resolve()
      })
    },

    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeRefreshToken()
        removeToken()
        resolve()
      })
    }
  }
}

export default user
